import { useState, useEffect } from 'react'

export default function useDebounce<T>(value: T, delay: number): [T, boolean] {
    const [debouncedValue, setDebouncedValue] = useState<T>(value)
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        setLoading(true)

        const handler = setTimeout(() => {
            setDebouncedValue(value)
            setLoading(false)
        }, delay)

        return () => {
            clearTimeout(handler)
        }
    }, [value, delay])

    return [debouncedValue, loading]
}
